import React from "react";
import { UserListType } from "../../../../../redux/slices/user/Types";

const includesSearchTerm = (value: string | null | undefined, term: string) =>
  (value ?? "").toLowerCase().includes(term);

export const useFilteredUserList = (
  users: UserListType,
  searchTerm: string
) => {
  return React.useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return users;

    return users.filter((user) => {
      return (
        includesSearchTerm(user.first_name, term) ||
        includesSearchTerm(user.last_name, term) ||
        includesSearchTerm(user.email, term)
      );
    });
  }, [users, searchTerm]);
};
